export default __webpack_public_path__ + "static/media/sabt.cf6910b1.png";